<div
  id="pcoded"
  class="pcoded"
  [attr.nav-type]="navType"
  [attr.theme-layout]="themeLayout"
  [attr.vertical-placement]="verticalPlacement"
  [attr.vertical-layout]="verticalLayout"
  [attr.pcoded-device-type]="pcodedDeviceType"
  [attr.vertical-nav-type]="verticalNavType"
  [attr.vertical-effect]="verticalEffect"
  [attr.vnavigation-view]="vnavigationView"
  [attr.fream-type]="freamType"
  [attr.sidebar-img]="sidebarImg"
  [attr.sidebar-img-type]="sidebarImgType"
  [attr.layout-type]="layoutType"
  (window:resize)="onResize($event)"
>
  <div class="pcoded-overlay-box"></div>
  <div class="pcoded-container navbar-wrapper">
    <nav
      class="navbar header-navbar pcoded-header"
      [attr.header-theme]="headerTheme"
      [attr.pcoded-header-position]="pcodedHeaderPosition"
    >
      <div class="navbar-wrapper custom-nav">
        <div class="navbar-logo">
          <a
            class="mobile-menu"
            id="mobile-collapse"
            href="javascript:"
            (click)="toggleOpened()"
            [exclude]="'#main_navbar'"
            (clickOutside)="onClickedOutsideSidebar($event)"
          >
            <i class="ti-menu"></i>
          </a>
          <a [routerLink]="['/admin/dashboard/']">
            <img
              class="img-fluid piptle mb-0"
              src="assets/images/maaya_logo.svg"
              alt="Theme-Logo"
            />
          </a>
          <!-- <a href="javascript:" class="mobile-options" (click)="toggleHeaderNavRight()">
            <i class="ti-more"></i>
          </a> -->
        </div>
        <div
          class="navbar-container container-fluid d-flex justify-content-end"
        >
          <ul class="nav-left">
            <li>
              <div class="sidebar_toggle">
                <a href="javascript:">
                  <i class="ti-menu"></i>
                </a>
              </div>
            </li>
            <!-- <li class="header-search">
              <div id="main-search" class="main-search morphsearch-search">
                <div class="input-group">
                  <span class="input-group-prepend search-close" (click)="searchOff()">
                    <i class="ti-close input-group-text"></i>
                  </span>
                  <input class="form-control" [style.width]="searchWidthString">
                  <span class="input-group-append search-btn" (click)="searchOn()">
                    <i class="ti-search input-group-text"></i>
                  </span>
                </div>
              </div>
            </li> -->
            <!-- <li appToggleFullScreen>
              <a href="javascript:">
                <i class="ti-fullscreen"></i>
              </a>
            </li> -->
          </ul>
          <ul
            [@mobileHeaderNavRight]="navRight"
            [ngClass]="navRight"
            class="nav-right"
          >
            <li
              (clickOutside)="notificationOutsideClick('live')"
              class="header-notification"
              [ngClass]="liveNotificationClass"
              (click)="toggleLiveNotification()"
            >
              <a href="javascript:">
                <i class="ti-bell"></i>
                <span *ngIf="notificationCount != 0" class="badge bg-c-pink">{{
                  notificationCount
                }}</span>
              </a>

              <ul
                [@notificationBottom]="liveNotification"
                class="show-notification"
              >
                <li>
                  <h6>Notifications</h6>
                </li>
                <li class="no-hover" *ngIf="notificationsLoader">
                  <div class="box-loader">
                    <div class="center-loader">
                      <svg
                        class="lds-comets"
                        width="100%"
                        height="100%"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 100 100"
                        preserveAspectRatio="xMidYMid"
                      >
                        <g transform="rotate(208.756 50 50)">
                          <animateTransform
                            attributeName="transform"
                            type="rotate"
                            repeatCount="indefinite"
                            values="360 50 50;0 50 50"
                            keyTimes="0;1"
                            dur="2.3s"
                            keySplines="0.5 0.5 0.5 0.5"
                            calcMode="spline"
                          ></animateTransform>
                          <path
                            fill="#85ffbd"
                            d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"
                          ></path>
                          <path
                            fill="#316598"
                            d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"
                          ></path>
                          <path
                            fill="#a4bcc2"
                            d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"
                          ></path>
                        </g>
                      </svg>
                    </div>
                  </div>
                </li>

                <div class="clearfix" *ngIf="notificationsList.length == 0">
                  <div class="not-inner">
                    <p class="no-notifications text-centered">
                      No Notifications
                    </p>
                  </div>
                </div>

                <ng-container *ngFor="let notification of notificationsList">
                  <li
                    *ngIf="
                      notification.NotificationType == 'ICO_Stage_Updation'
                    "
                    (click)="updateNotificationStatus(notification._id)"
                  >
                    <div class="media">
                      <img
                        class="d-flex align-self-center img-radius"
                        src="assets/images/ico-stage.png"
                        alt="Generic placeholder image"
                      />
                      <div class="media-body">
                        <p class="notification-msg">
                          {{ notification.NotificationText }}
                        </p>
                        <span
                          class="red-dot"
                          *ngIf="!notification.IsRead"
                        ></span>
                      </div>
                    </div>
                  </li>
                  <li
                    *ngIf="
                      notification.NotificationType ==
                      'Transaction_Confirmation'
                    "
                    (click)="updateNotificationStatus(notification._id)"
                  >
                    <div
                      class="media"
                      (click)="updateNotificationStatus(notification._id)"
                    >
                      <img
                        class="d-flex align-self-center img-radius"
                        src="assets/images/transaction.png"
                        alt="Generic placeholder image"
                      />
                      <div class="media-body">
                        <p class="notification-msg">
                          {{ notification.NotificationText }}
                        </p>
                        <span
                          class="red-dot"
                          *ngIf="!notification.IsRead"
                        ></span>
                      </div>
                    </div>
                  </li>
                  <li
                    *ngIf="notification.NotificationType == 'USER_REGISTRATION'"
                    (click)="updateNotificationStatus(notification._id)"
                  >
                    <div
                      class="media"
                      (click)="updateNotificationStatus(notification._id)"
                    >
                      <img
                        class="d-flex align-self-center img-radius"
                        src="assets/images/protect.png"
                        alt="Generic placeholder image"
                      />
                      <div class="media-body">
                        <p class="notification-msg">
                          {{ notification.NotificationText }}
                        </p>
                        <span
                          class="red-dot"
                          *ngIf="!notification.IsRead"
                        ></span>
                      </div>
                    </div>
                  </li>
                  <li
                    *ngIf="
                      notification.NotificationType ==
                      'WIRE_TRANSFER_SUBMISSION'
                    "
                    (click)="updateNotificationStatus(notification._id)"
                  >
                    <div
                      class="media"
                      (click)="updateNotificationStatus(notification._id)"
                    >
                      <img
                        class="d-flex align-self-center img-radius"
                        src="assets/images/wire-transfer.svg"
                        alt="Generic placeholder image"
                      />
                      <div class="media-body">
                        <p class="notification-msg">
                          {{ notification.NotificationText }}
                        </p>
                        <span
                          class="red-dot"
                          *ngIf="!notification.IsRead"
                        ></span>
                      </div>
                    </div>
                  </li>
                </ng-container>
                <li class="bottom-see-all">
                  <a class="see-all-link-btn" (click)="seeAllNotifications()"
                    >See All</a
                  >
                </li>
              </ul>
            </li>
            <!-- <li class="">
              <a href="javascript:" (click)="toggleChat()">
                <i class="ti-comments"></i>
                <span class="badge bg-c-green"></span>
              </a>
            </li> -->
            <li
              (clickOutside)="notificationOutsideClick('profile')"
              class="user-profile header-notification"
              [ngClass]="profileNotificationClass"
              (click)="toggleProfileNotification()"
            >
              <a href="javascript:">
                <span>{{ adminObj.firstName }}</span>
                <i class="ti-angle-down"></i>
              </a>
              <ul
                [@notificationBottom]="profileNotification"
                class="show-notification profile-notification"
              >
                <li>
                  <a [routerLink]="['/admin/settings/']">
                    <i class="ti-settings"></i> Settings
                  </a>
                </li>
                <li>
                  <a [routerLink]="['/admin/user/profile/']">
                    <i class="ti-user"></i> Profile
                  </a>
                </li>

                <li>
                  <a (click)="logout()">
                    <i class="ti-layout-sidebar-left"></i> Logout
                  </a>
                </li>
              </ul>
            </li>
          </ul>
          <!-- Sidebar chat start -->
          <!-- <div [@slideInOut]="chatSlideInOut" id="sidebar" class="users p-chat-user showChat" [ngClass]="chatSlideInOut">
            <div class="had-container">
              <div class="card card_main p-fixed users-main">
                <div class="user-box">
                  <div class="chat-search-box">
                    <a class="back_friendlist" (click)="toggleChat()">
                      <i class="fa fa-chevron-left"></i>
                    </a>
                    <div class="right-ti-control input-group">
                      <input class="form-control search-text" placeholder="Search Friend" id="search-friends">
                      <div class="form-icon input-group-append">
                        <label class="input-group-text">
                          <i class="fa fa-search"></i>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="main-friend-list">
                    <div class="media userlist-box" data-username="Josephin Doe" placement="left" ngbTooltip="Josephin Doe" (click)="toggleInnerChat()">
                      <a class="media-left" href="javascript:">
                        <img class="media-object img-radius img-radius" src="assets/images/avatar-3.jpg" alt="Josephin Doe">
                        <div class="live-status bg-success"></div>
                      </a>
                      <div class="media-body">
                        <div class="f-13 chat-header">Josephin Doe</div>
                      </div>
                    </div>
                    <div class="media userlist-box" data-username="Lary Doe" placement="left" ngbTooltip="Lary Doe" (click)="toggleInnerChat()">
                      <a class="media-left" href="javascript:">
                        <img class="media-object img-radius" src="assets/images/avatar-2.jpg" alt="Lary Doe">
                        <div class="live-status bg-danger"></div>
                      </a>
                      <div class="media-body">
                        <div class="f-13 chat-header">Lary Doe</div>
                      </div>
                    </div>
                    <div class="media userlist-box" data-username="Alice" placement="left" ngbTooltip="Alice" (click)="toggleInnerChat()">
                      <a class="media-left" href="javascript:">
                        <img class="media-object img-radius" src="assets/images/avatar-4.jpg" alt="Alice">
                        <div class="live-status bg-success"></div>
                      </a>
                      <div class="media-body">
                        <div class="f-13 chat-header">Alice</div>
                      </div>
                    </div>
                    <div class="media userlist-box" data-username="Alia" placement="left" ngbTooltip="Alia" (click)="toggleInnerChat()">
                      <a class="media-left" href="javascript:">
                        <img class="media-object img-radius" src="assets/images/avatar-3.jpg" alt="Alia">
                        <div class="live-status bg-success"></div>
                      </a>
                      <div class="media-body">
                        <div class="f-13 chat-header">Alia</div>
                      </div>
                    </div>
                    <div class="media userlist-box" data-username="Suzen" placement="left" ngbTooltip="Suzen" (click)="toggleInnerChat()">
                      <a class="media-left" href="javascript:">
                        <img class="media-object img-radius" src="assets/images/avatar-2.jpg" alt="Suzen">
                        <div class="live-status bg-danger"></div>
                      </a>
                      <div class="media-body">
                        <div class="f-13 chat-header">Suzen</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <!-- Sidebar inner chat start-->
          <!-- <div [@slideInOut]="innerChatSlideInOut" class="showChat_inner">
            <div class="media chat-inner-header">
              <a class="back_chatBox">
                <i class="fa fa-chevron-left" (click)="toggleInnerChat()"></i> Josephin Doe
              </a>
            </div>
            <div class="media chat-messages">
              <a class="media-left photo-table" href="javascript:">
                <img class="media-object img-radius img-radius m-t-5" src="assets/images/avatar-3.jpg" alt="Generic placeholder image">
              </a>
              <div class="media-body chat-menu-content">
                <div class="">
                  <p class="chat-cont">I'm just looking around. Will you tell me something about yourself?</p>
                  <p class="chat-time">8:20 a.m.</p>
                </div>
              </div>
            </div>
            <div class="media chat-messages">
              <div class="media-body chat-menu-reply">
                <div class="">
                  <p class="chat-cont">I'm just looking around. Will you tell me something about yourself?</p>
                  <p class="chat-time">8:20 a.m.</p>
                </div>
              </div>
              <div class="media-right photo-table">
                <a href="javascript:">
                  <img class="media-object img-radius img-radius m-t-5" src="assets/images/avatar-4.jpg" alt="Generic placeholder image">
                </a>
              </div>
            </div>
            <div class="chat-reply-box p-b-20">
              <div class="right-ti-control input-group">
                <input type="text" class="form-control search-text" placeholder="Share Your Thoughts">
                <div class="form-icon input-group-append">
                  <label class="input-group-text">
                    <i class="fa fa-paper-plane"></i>
                  </label>
                </div>
              </div>
            </div>
          </div> -->
          <!-- Sidebar inner chat end-->
        </div>
      </div>
    </nav>
    <div class="pcoded-main-container" [style.margin-top]="headerFixedMargin">
      <div class="pcoded-wrapper">
        <nav
          id="main_navbar"
          class="pcoded-navbar"
          (clickOutside)="onClickedOutsideSidebar($event)"
          [exclude]="'#mobile-collapse'"
          [attr.pcoded-header-position]="pcodedHeaderPosition"
          [attr.navbar-theme]="navBarTheme"
          [attr.active-item-theme]="activeItemTheme"
          sub-item-theme="theme2"
          active-item-style="style0"
          [attr.pcoded-navbar-position]="pcodedSidebarPosition"
        >
          <div class="pcoded-inner-navbar main-menu" appAccordion>
            <perfect-scrollbar
              [style.max-width]="'235px'"
              [style.max-height]="sidebarFixedHeight"
              [config]="config"
            >
              <span
                *ngFor="let asideItems of menuItems.getAll()"
                class="d-color"
              >
                <div
                  class="pcoded-navigation-label"
                  [attr.menu-title-theme]="menuTitleTheme"
                >
                  {{ asideItems.label }}
                </div>
                <ul
                  class="pcoded-item pcoded-left-item"
                  [attr.item-border]="itemBorder"
                  [attr.item-border-style]="itemBorderStyle"
                  [attr.subitem-border]="subItemBorder"
                  *ngFor="let asideItem of asideItems.main"
                  appAccordionLink
                  group="{{ asideItem.state }}"
                >
                  <li
                    [routerLinkActive]="['active']"
                    *ngIf="asideItem.type === 'external'"
                    appAccordionLink
                    group="{{ asideItem.state }}"
                  >
                    <a
                      href="{{ asideItem.external }}"
                      target="{{ asideItem.target ? '_blank' : '_self' }}"
                      appAccordionToggle
                    >
                      <span class="pcoded-micon">
                        <i class="{{ asideItem.icon }}"></i>
                        <b>{{ asideItem.short_label }}</b>
                      </span>
                      <span class="pcoded-mtext">{{ asideItem.name }}</span>
                      <span
                        *ngFor="let asideBadge of asideItem.badge"
                        class="pcoded-badge label label-{{ asideBadge.type }}"
                        >{{ asideBadge.value }}</span
                      >
                      <span class="pcoded-mcaret"></span>
                    </a>
                  </li>

                  <li
                    [routerLinkActive]="['active']"
                    *ngIf="asideItem.type === 'link'"
                    appAccordionLink
                    group="{{ asideItem.state }}"
                  >
                    <a
                      [routerLink]="[
                        '/',
                        asideItem.main_state,
                        asideItem.state
                      ]"
                      target="{{ asideItem.target ? '_blank' : '_self' }}"
                      appAccordionToggle
                      *ngIf="asideItem.main_state; else mainContent"
                    >
                      <span class="pcoded-micon">
                        <i class="{{ asideItem.icon }}"></i>
                        <b>{{ asideItem.short_label }}</b>
                      </span>
                      <span class="pcoded-mtext">{{ asideItem.name }}</span>
                      <span
                        *ngFor="let asideBadge of asideItem.badge"
                        class="pcoded-badge label label-{{ asideBadge.type }}"
                        >{{ asideBadge.value }}</span
                      >
                      <span class="pcoded-mcaret"></span>
                    </a>
                    <ng-template #mainContent>
                      <a
                        [routerLink]="['/', asideItem.state]"
                        target="{{ asideItem.target ? '_blank' : '_self' }}"
                        appAccordionToggle
                      >
                        <span class="pcoded-micon">
                          <i class="{{ asideItem.icon }}"></i>
                          <b>{{ asideItem.short_label }}</b>
                        </span>
                        <span class="pcoded-mtext">{{ asideItem.name }}</span>
                        <span
                          *ngFor="let asideBadge of asideItem.badge"
                          class="pcoded-badge label label-{{ asideBadge.type }}"
                          >{{ asideBadge.value }}</span
                        >
                        <span class="pcoded-mcaret"></span>
                      </a>
                    </ng-template>
                  </li>
                  <li
                    [routerLinkActive]="['active']"
                    *ngIf="asideItem.type === 'sub'"
                    class="pcoded-hasmenu"
                    [attr.dropdown-icon]="dropDownIcon"
                    [attr.subitem-icon]="subItemIcon"
                    appAccordionLink
                    group="{{ asideItem.state }}"
                  >
                    <a
                      [routerLinkActive]="['active']"
                      href="javascript:;"
                      appAccordionToggle
                    >
                      <span class="pcoded-micon">
                        <i class="{{ asideItem.icon }}"></i>
                        <b>{{ asideItem.short_label }}</b>
                      </span>
                      <span class="pcoded-mtext">{{ asideItem.name }}</span>
                      <span
                        *ngFor="let asideBadge of asideItem.badge"
                        class="pcoded-badge label label-{{ asideBadge.type }}"
                        >{{ asideBadge.value }}</span
                      >
                      <span class="pcoded-mcaret"></span>
                    </a>
                    <ul class="pcoded-submenu">
                      <ng-template
                        ngFor
                        let-asideChildren
                        [ngForOf]="asideItem.children"
                      >
                        <li
                          [routerLinkActive]="['active']"
                          *ngIf="asideChildren.type !== 'sub'"
                        >
                          <a
                            [routerLink]="[
                              '/admin',
                              asideItem.state,
                              asideChildren.state
                            ]"
                            target="{{
                              asideChildren.target ? '_blank' : '_self'
                            }}"
                          >
                            <span class="pcoded-micon">
                              <i class="ti-angle-right"></i>
                            </span>
                            <span class="pcoded-mtext"
                              >{{ asideChildren.name }}
                            </span>
                            <span
                              *ngFor="
                                let asideChildrenBadge of asideChildren.badge
                              "
                              class="pcoded-badge label label-{{
                                asideChildrenBadge.type
                              }}"
                              >{{ asideChildrenBadge.value }}</span
                            >
                            <span class="pcoded-mcaret"></span>
                          </a>
                        </li>

                        <li
                          [routerLinkActive]="['active']"
                          class="pcoded-hasmenu"
                          [attr.dropdown-icon]="dropDownIcon"
                          [attr.subitem-icon]="subItemIcon"
                          *ngIf="asideChildren.type === 'sub'"
                          appAccordionLink
                          group="sub-toggled"
                        >
                          <a href="javascript:;" appAccordionToggle>
                            <span class="pcoded-micon">
                              <i class="ti-direction-alt"></i>
                            </span>
                            <span class="pcoded-mtext">{{
                              asideChildren.name
                            }}</span>
                            <span
                              *ngFor="
                                let asideChildrenBadge of asideChildren.badge
                              "
                              class="pcoded-badge label label-{{
                                asideChildrenBadge.type
                              }}"
                              >{{ asideChildrenBadge.value }}</span
                            >
                            <span class="pcoded-mcaret"></span>
                          </a>
                          <ul class="pcoded-submenu">
                            <ng-template
                              ngFor
                              let-asideChildrenSub
                              [ngForOf]="asideChildren.children"
                            >
                              <li [routerLinkActive]="['active']">
                                <a
                                  [routerLink]="[
                                    '/admin',
                                    asideItem.state,
                                    asideChildren.state,
                                    asideChildrenSub.state
                                  ]"
                                  target="{{
                                    asideChildrenSub.target ? '_blank' : '_self'
                                  }}"
                                >
                                  <span class="pcoded-micon">
                                    <i class="ti-angle-right"></i>
                                  </span>
                                  <span class="pcoded-mtext">{{
                                    asideChildrenSub.name
                                  }}</span>
                                  <span
                                    *ngFor="
                                      let asideChildrenSubBadge of asideChildrenSub.badge
                                    "
                                    class="pcoded-badge label label-{{
                                      asideChildrenSubBadge.type
                                    }}"
                                    >{{ asideChildrenSubBadge.value }}</span
                                  >
                                  <span class="pcoded-mcaret"></span>
                                </a>
                              </li>
                            </ng-template>
                          </ul>
                        </li>
                      </ng-template>
                    </ul>
                  </li>
                </ul>
              </span>
            </perfect-scrollbar>
          </div>
        </nav>
        <div class="pcoded-content">
          <div class="pcoded-inner-content">
            <!-- Main-body start -->
            <div class="main-body">
              <div class="page-wrapper">
                <router-outlet>
                  <app-title></app-title>
                  <app-breadcrumbs></app-breadcrumbs>
                  <app-spinner></app-spinner>
                </router-outlet>
              </div>
            </div>
            <div id="styleSelector" [ngClass]="configOpenRightBar">
              <!-- <div class="selector-toggle">
                <a href="javascript:" placement="left" ngbTooltip="Live layout customizer" (click)="toggleRightbar()"></a>
              </div> -->
              <ul>
                <li>
                  <p class="selector-title main-title st-main-title">
                    <b>Gradient </b>able Customizer
                  </p>
                  <span class="text-muted"
                    >Live customizer with tons of options</span
                  >
                </li>
                <li>
                  <p class="selector-title">Main layouts</p>
                </li>
                <li>
                  <div class="theme-color">
                    <a
                      href="javascript:"
                      (click)="setNavBarTheme('themelight1')"
                      navbar-theme="themelight1"
                      placement="top"
                      ngbTooltip="Light Sidebar"
                    >
                      <span class="head"></span>
                      <span class="cont"></span>
                    </a>
                    <a
                      href="javascript:"
                      (click)="setNavBarTheme('theme1')"
                      navbar-theme="theme1"
                      placement="top"
                      ngbTooltip="Dark Sidebar"
                    >
                      <span class="head"></span>
                      <span class="cont"></span>
                    </a>
                    <a
                      href="javascript:"
                      (click)="setLayoutType('img')"
                      layout-type="img"
                      placement="top"
                      ngbTooltip="Sidebar with image"
                    >
                      <span class="head"></span>
                      <span class="cont"></span>
                    </a>
                    <a
                      href="javascript:"
                      (click)="setLayoutType('light')"
                      layout-type="light"
                      placement="top"
                      ngbTooltip="Light Layout"
                    >
                      <span class="head"></span>
                      <span class="cont"></span>
                    </a>
                    <a
                      href="javascript:"
                      (click)="setLayoutType('dark')"
                      layout-type="dark"
                      placement="top"
                      ngbTooltip="Dark Layout"
                    >
                      <span class="head"></span>
                      <span class="cont"></span>
                    </a>
                  </div>
                </li>
              </ul>
              <perfect-scrollbar
                [style.max-width]="'100%'"
                [style.max-height]="'calc(100vh - 495px)'"
                [config]="config"
              >
                <div class="style-cont m-t-10">
                  <div class="md-tabs">
                    <ngb-tabset>
                      <ngb-tab title="Layouts">
                        <ng-template ngbTabContent>
                          <div [@fadeInOutTranslate] class="m-t-15">
                            <ul>
                              <li class="theme-option">
                                <div class="checkbox-fade fade-in-primary">
                                  <label>
                                    <input
                                      type="checkbox"
                                      value="false"
                                      id="theme-layout"
                                      name="vertical-item-border"
                                      [checked]="isVerticalLayoutChecked"
                                      (change)="setVerticalLayout()"
                                    />
                                    <span class="cr">
                                      <i
                                        class="cr-icon fa fa-check txt-success"
                                      ></i>
                                    </span>
                                    <span>Box Layout - with patterns</span>
                                  </label>
                                </div>
                              </li>
                              <li
                                class="theme-option"
                                id="bg-pattern-visiblity"
                                [ngClass]="displayBoxLayout"
                              >
                                <div class="theme-color">
                                  <a
                                    href="javascript:"
                                    class="small"
                                    (click)="setBackgroundPattern('pattern1')"
                                    themebg-pattern="pattern1"
                                  ></a>
                                  <a
                                    href="javascript:"
                                    class="small"
                                    (click)="setBackgroundPattern('pattern2')"
                                    themebg-pattern="pattern2"
                                  ></a>
                                  <a
                                    href="javascript:"
                                    class="small"
                                    (click)="setBackgroundPattern('pattern3')"
                                    themebg-pattern="pattern3"
                                  ></a>
                                  <a
                                    href="javascript:"
                                    class="small"
                                    (click)="setBackgroundPattern('pattern4')"
                                    themebg-pattern="pattern4"
                                  ></a>
                                  <a
                                    href="javascript:"
                                    class="small"
                                    (click)="setBackgroundPattern('pattern5')"
                                    themebg-pattern="pattern5"
                                  ></a>
                                  <a
                                    href="javascript:"
                                    class="small"
                                    (click)="setBackgroundPattern('pattern6')"
                                    themebg-pattern="pattern6"
                                  ></a>
                                </div>
                              </li>
                              <li class="theme-option">
                                <div class="checkbox-fade fade-in-primary">
                                  <label>
                                    <input
                                      type="checkbox"
                                      value="false"
                                      id="sidebar-position"
                                      name="sidebar-position"
                                      [checked]="isSidebarChecked"
                                      (change)="setSidebarPosition()"
                                    />
                                    <span class="cr">
                                      <i
                                        class="cr-icon fa fa-check txt-success"
                                      ></i>
                                    </span>
                                    <span>Fixed Sidebar Position</span>
                                  </label>
                                </div>
                              </li>
                              <li class="theme-option">
                                <div class="checkbox-fade fade-in-primary">
                                  <label>
                                    <input
                                      type="checkbox"
                                      value="false"
                                      id="header-position"
                                      name="header-position"
                                      [checked]="isHeaderChecked"
                                      (change)="setHeaderPosition()"
                                    />
                                    <span class="cr">
                                      <i
                                        class="cr-icon fa fa-check txt-success"
                                      ></i>
                                    </span>
                                    <span>Fixed Header Position</span>
                                  </label>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </ng-template>
                      </ngb-tab>
                      <ngb-tab title="Sidebar Settings">
                        <ng-template ngbTabContent>
                          <div [@fadeInOutTranslate] class="m-t-15">
                            <ul>
                              <li class="theme-option">
                                <p class="sub-title drp-title">Menu Type</p>
                                <div class="form-radio" id="menu-effect">
                                  <div
                                    class="radio radiofill radio-primary radio-inline"
                                    ngbTooltip="Color icon"
                                  >
                                    <label>
                                      <input
                                        type="radio"
                                        name="radio"
                                        value="st1"
                                        (click)="
                                          this.navType = $event.target.value
                                        "
                                      />
                                      <i class="helper"></i>
                                      <span class="micon st1">
                                        <i class="ti-home"></i>
                                      </span>
                                    </label>
                                  </div>
                                  <div
                                    class="radio radiofill radio-success radio-inline"
                                    ngbTooltip="Simple icon"
                                  >
                                    <label>
                                      <input
                                        type="radio"
                                        name="radio"
                                        value="st2"
                                        (click)="
                                          this.navType = $event.target.value
                                        "
                                        checked="true"
                                      />
                                      <i class="helper"></i>
                                      <span class="micon st2">
                                        <i class="ti-home"></i>
                                      </span>
                                    </label>
                                  </div>
                                </div>
                              </li>
                              <li class="theme-option">
                                <p class="sub-title drp-title">
                                  SideBar Effect
                                </p>
                                <select
                                  id="vertical-menu-effect"
                                  class="form-control minimal"
                                  (change)="
                                    this.verticalEffect = $event.target.value
                                  "
                                >
                                  <option value="shrink" selected>
                                    shrink
                                  </option>
                                  <option value="overlay">overlay</option>
                                  <option value="push">Push</option>
                                </select>
                              </li>
                              <li class="theme-option">
                                <p class="sub-title drp-title">
                                  Hide/Show Border
                                </p>
                                <select
                                  id="vertical-border-style"
                                  class="form-control minimal"
                                  (change)="
                                    this.itemBorderStyle = $event.target.value
                                  "
                                >
                                  <option value="solid" selected>
                                    Style 1
                                  </option>
                                  <option value="dotted">Style 2</option>
                                  <option value="dashed">Style 3</option>
                                  <option value="none" selected>
                                    No Border
                                  </option>
                                </select>
                              </li>
                              <li class="theme-option">
                                <p class="sub-title drp-title">
                                  Drop-Down Icon
                                </p>
                                <select
                                  id="vertical-dropdown-icon"
                                  class="form-control minimal"
                                  (change)="
                                    this.dropDownIcon = $event.target.value
                                  "
                                >
                                  <option value="style1" selected>
                                    Style 1
                                  </option>
                                  <option value="style2">style 2</option>
                                  <option value="style3" selected>
                                    style 3
                                  </option>
                                </select>
                              </li>
                              <li class="theme-option">
                                <p class="sub-title drp-title">
                                  Sub Menu Drop-down Icon
                                </p>
                                <select
                                  id="vertical-subitem-icon"
                                  class="form-control minimal"
                                  (change)="
                                    this.subItemIcon = $event.target.value
                                  "
                                >
                                  <option value="style1">Style 1</option>
                                  <option value="style2">style 2</option>
                                  <option value="style3">style 3</option>
                                  <option value="style4">style 4</option>
                                  <option value="style5">style 5</option>
                                  <option value="style6">style 6</option>
                                  <option value="style7" selected>
                                    style 7
                                  </option>
                                </select>
                              </li>
                            </ul>
                          </div>
                        </ng-template>
                      </ngb-tab>
                    </ngb-tabset>
                  </div>
                  <div class="tab-content tabs">
                    <ul>
                      <li>
                        <p class="selector-title">Header color</p>
                      </li>
                      <li>
                        <span class="selector-title">Dark</span>
                      </li>
                      <li class="theme-option">
                        <div class="theme-color">
                          <a
                            href="javascript:"
                            class="header-theme"
                            (click)="
                              this.activeItemTheme = this.headerTheme = 'theme1'
                            "
                            header-theme="theme1"
                          >
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a
                            href="javascript:"
                            class="header-theme"
                            (click)="
                              this.activeItemTheme = this.headerTheme = 'theme2'
                            "
                            header-theme="theme2"
                          >
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a
                            href="javascript:"
                            class="header-theme"
                            (click)="
                              this.activeItemTheme = this.headerTheme = 'theme3'
                            "
                            header-theme="theme3"
                          >
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a
                            href="javascript:"
                            class="header-theme"
                            (click)="
                              this.activeItemTheme = this.headerTheme = 'theme4'
                            "
                            header-theme="theme4"
                          >
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a
                            href="javascript:"
                            class="header-theme"
                            (click)="
                              this.activeItemTheme = this.headerTheme = 'theme5'
                            "
                            header-theme="theme5"
                          >
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a
                            href="javascript:"
                            class="header-theme"
                            (click)="
                              this.activeItemTheme = this.headerTheme = 'theme6'
                            "
                            header-theme="theme6"
                          >
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                        </div>
                      </li>
                      <li>
                        <span class="selector-title">light</span>
                      </li>
                      <li class="theme-option">
                        <div class="theme-color">
                          <a
                            href="javascript:"
                            class="header-theme"
                            (click)="
                              this.activeItemTheme = 'theme7';
                              this.headerTheme = 'themelight1'
                            "
                            header-theme="themelight1"
                          >
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a
                            href="javascript:"
                            class="header-theme"
                            (click)="
                              this.activeItemTheme = 'theme8';
                              this.headerTheme = 'themelight2'
                            "
                            header-theme="themelight2"
                          >
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a
                            href="javascript:"
                            class="header-theme"
                            (click)="
                              this.activeItemTheme = 'theme9';
                              this.headerTheme = 'themelight3'
                            "
                            header-theme="themelight3"
                          >
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a
                            href="javascript:"
                            class="header-theme"
                            (click)="
                              this.activeItemTheme = 'theme10';
                              this.headerTheme = 'themelight4'
                            "
                            header-theme="themelight4"
                          >
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a
                            href="javascript:"
                            class="header-theme"
                            (click)="
                              this.activeItemTheme = 'theme11';
                              this.headerTheme = 'themelight5'
                            "
                            header-theme="themelight5"
                          >
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                          <a
                            href="javascript:"
                            class="header-theme"
                            (click)="
                              this.activeItemTheme = 'theme12';
                              this.headerTheme = 'themelight6'
                            "
                            header-theme="themelight6"
                          >
                            <span class="head"></span>
                            <span class="cont"></span>
                          </a>
                        </div>
                      </li>
                      <li>
                        <p class="selector-title">Navbar image</p>
                      </li>
                      <li class="theme-option">
                        <div class="theme-color">
                          <a
                            href="javascript:"
                            class="navbg-pattern image"
                            (click)="this.sidebarImgType = 'img1'"
                            navbg-pattern="img1"
                          ></a>
                          <a
                            href="javascript:"
                            class="navbg-pattern image"
                            (click)="this.sidebarImgType = 'img2'"
                            navbg-pattern="img2"
                          ></a>
                          <a
                            href="javascript:"
                            class="navbg-pattern image"
                            (click)="this.sidebarImgType = 'img3'"
                            navbg-pattern="img3"
                          ></a>
                          <a
                            href="javascript:"
                            class="navbg-pattern image"
                            (click)="this.sidebarImgType = 'img4'"
                            navbg-pattern="img4"
                          ></a>
                          <a
                            href="javascript:"
                            class="navbg-pattern image"
                            (click)="this.sidebarImgType = 'img5'"
                            navbg-pattern="img5"
                          ></a>
                        </div>
                      </li>
                      <li>
                        <p class="selector-title">Active link color</p>
                      </li>
                      <li class="theme-option">
                        <div class="theme-color">
                          <a
                            href="javascript:"
                            (click)="this.activeItemTheme = 'theme1'"
                            class="small"
                            active-item-theme="theme1"
                          ></a>
                          <a
                            href="javascript:"
                            (click)="this.activeItemTheme = 'theme2'"
                            class="small"
                            active-item-theme="theme2"
                          ></a>
                          <a
                            href="javascript:"
                            (click)="this.activeItemTheme = 'theme3'"
                            class="small"
                            active-item-theme="theme3"
                          ></a>
                          <a
                            href="javascript:"
                            (click)="this.activeItemTheme = 'theme4'"
                            class="small"
                            active-item-theme="theme4"
                          ></a>
                          <a
                            href="javascript:"
                            (click)="this.activeItemTheme = 'theme5'"
                            class="small"
                            active-item-theme="theme5"
                          ></a>
                          <a
                            href="javascript:"
                            (click)="this.activeItemTheme = 'theme6'"
                            class="small"
                            active-item-theme="theme6"
                          ></a>
                          <a
                            href="javascript:"
                            (click)="this.activeItemTheme = 'theme7'"
                            class="small"
                            active-item-theme="theme7"
                          ></a>
                          <a
                            href="javascript:"
                            (click)="this.activeItemTheme = 'theme8'"
                            class="small"
                            active-item-theme="theme8"
                          ></a>
                          <a
                            href="javascript:"
                            (click)="this.activeItemTheme = 'theme9'"
                            class="small"
                            active-item-theme="theme9"
                          ></a>
                          <a
                            href="javascript:"
                            (click)="this.activeItemTheme = 'theme10'"
                            class="small"
                            active-item-theme="theme10"
                          ></a>
                          <a
                            href="javascript:"
                            (click)="this.activeItemTheme = 'theme11'"
                            class="small"
                            active-item-theme="theme11"
                          ></a>
                          <a
                            href="javascript:"
                            (click)="this.activeItemTheme = 'theme12'"
                            class="small"
                            active-item-theme="theme12"
                          ></a>
                        </div>
                      </li>
                      <li>
                        <p class="selector-title">Menu Caption Color</p>
                      </li>
                      <li class="theme-option">
                        <div class="theme-color">
                          <a
                            href="javascript:"
                            class="small"
                            (click)="this.menuTitleTheme = 'theme1'"
                            lheader-theme="theme1"
                          ></a>
                          <a
                            href="javascript:"
                            class="small"
                            (click)="this.menuTitleTheme = 'theme2'"
                            lheader-theme="theme2"
                          ></a>
                          <a
                            href="javascript:"
                            class="small"
                            (click)="this.menuTitleTheme = 'theme3'"
                            lheader-theme="theme3"
                          ></a>
                          <a
                            href="javascript:"
                            class="small"
                            (click)="this.menuTitleTheme = 'theme4'"
                            lheader-theme="theme4"
                          ></a>
                          <a
                            href="javascript:"
                            class="small"
                            (click)="this.menuTitleTheme = 'theme5'"
                            lheader-theme="theme5"
                          ></a>
                          <a
                            href="javascript:"
                            class="small"
                            (click)="this.menuTitleTheme = 'theme6'"
                            lheader-theme="theme6"
                          ></a>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </perfect-scrollbar>
              <ul>
                <li>
                  <a
                    href="https://codedthemes.com/"
                    target="_blank"
                    class="btn btn-success btn-block m-r-15 m-t-10 m-b-10"
                    >Profile</a
                  >
                  <a
                    href="https://codedthemes.com/item/category/templates/admin-templates/"
                    target="_blank"
                    class="btn btn-primary btn-block m-r-15 m-t-5 m-b-10"
                    >Online Documentation
                  </a>
                </li>
                <li class="text-center">
                  <span class="text-center f-18 m-t-15 m-b-15 d-block"
                    >Thank you for sharing !</span
                  >
                  <a
                    href="https://www.facebook.com/codedthemes"
                    target="_blank"
                    class="btn btn-facebook soc-icon m-b-20"
                  >
                    <i class="fa fa-facebook"></i>
                  </a>
                  <a
                    href="https://twitter.com/codedthemes"
                    target="_blank"
                    class="btn btn-twitter soc-icon m-l-20 m-b-20"
                  >
                    <i class="fa fa-twitter"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
